import React from "react";
import { portfolio } from "@/data/portfolio";

const Footer = () => {
  const { meta } = portfolio;
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="px-5 md:px-10 py-10 md:py-14"
      style={{ borderTop: "1px solid var(--rule)" }}
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-end">
          <div className="md:col-span-4 font-serif text-2xl sm:text-3xl md:text-4xl tracking-tightest">
            {meta.nameSplit.first}
            <span className="display-italic ml-2" style={{ color: "var(--accent)" }}>{meta.nameSplit.last}</span>
          </div>

          <div className="md:col-span-5 font-mono text-[0.65rem] sm:text-[0.72rem] uppercase tracking-microcap leading-relaxed" style={{ color: "var(--ink-muted)" }}>
            {meta.volume}
            <span className="slash" />
            {meta.location}
            <span className="slash" />
            {meta.coords}
          </div>

          <div className="md:col-span-3 md:text-right font-mono text-[0.65rem] sm:text-[0.72rem] uppercase tracking-microcap leading-relaxed" style={{ color: "var(--ink-muted)" }}>
            © {year} {meta.name} — All rights reserved
          </div>
        </div>

        <div className="rule mt-6 md:mt-8" />

        <div className="mt-5 md:mt-6 flex flex-wrap items-center justify-between gap-3 sm:gap-4 font-mono text-[0.65rem] sm:text-[0.7rem] uppercase tracking-microcap" style={{ color: "var(--ink-muted)" }}>
          <span>Set in Fraunces · Inter · JetBrains Mono</span>
          <span className="hidden sm:inline">Hand-built · No templates</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
